import React,  { Component } from 'react';
import Parser from 'html-react-parser';
import DT from '../../utils/dateTime';
import tidingsData from '../../data/tidings.json';

class Tidings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tidings: []
    }
  }

  componentDidMount() {
    // sort tidings by timestamp descending
    const tidings = tidingsData.sort((t1, t2) => t2.timestamp - t1.timestamp);
    this.setState({tidings});
  }

  renderTidings = () => {
    return this.state.tidings.map(
      (t, i) => (
        <li key={i}>
          <div>{Parser(t.body)}</div>
          <p>
            {DT.getTodayCustom(t.timestamp)} - {DT.getTimeAt(t.timestamp)}
          </p>
        </li>
      )
    )
  }

  render() {
    return(
      <div className="Tidings">
        <ul>
          {this.renderTidings()}
        </ul>
      </div>
    )
  }
}

export default Tidings;
